import React, {useRef} from "react";
import SVG from "react-inlinesvg";

import medalIcon from '@icons/reward/medal'
import cupIcon from '@src/images/landing/cup';
import downloadIcon from '@icons/download/white'
import certificateIcon from '@icons/reward/certificate'
import finishflagIcon from '@icons/reward/finish-flag'
import CertificatePreviewModal from "@app/components/shared/CertificatePreviewModal";

export const ParticipationStatus = {
  ACHIEVEMENT: "achievement",
  MERIT: "merit",
  PARTICIPATION: "participation",
  DID_NOT_PARTICIPATE: 'did_not_participate'
};

export const ResultBannerVariant = {
  [ParticipationStatus.ACHIEVEMENT]: {
    icon: cupIcon,
    title: (event) => (event?.afterMainTour && event?.isAwardsAvailable) ? 'Your Certificate for the\u00A0Main\u00A0Round' : 'You Have a New Certificate!',
    footer: ({ handleOpenPreviewModal, event }) => <ResultBannerFooterPositive handleOpenPreviewModal={handleOpenPreviewModal} event={event} />,
  },
  [ParticipationStatus.MERIT]: {
    icon: medalIcon,
    title: (event) => (event?.afterMainTour && event?.isAwardsAvailable) ? 'Your Certificate for the\u00A0Main\u00A0Round' : 'You Have a New Certificate!',
    footer: ({ handleOpenPreviewModal, event }) => <ResultBannerFooterPositive handleOpenPreviewModal={handleOpenPreviewModal} event={event} />,
  },
  [ParticipationStatus.PARTICIPATION]: {
    icon: certificateIcon,
    title: (event) => (event?.afterMainTour && event?.isAwardsAvailable) ? 'Your Certificate for the\u00A0Main\u00A0Round' : 'You Have a New Certificate!',
    footer: ({ handleOpenPreviewModal, event }) => <ResultBannerFooterPositive handleOpenPreviewModal={handleOpenPreviewModal} event={event} />,
  },
  [ParticipationStatus.DID_NOT_PARTICIPATE]: {
    icon: finishflagIcon,
    title: 'You Can Do It Next Time!',
    footer: () => <ResultBannerFooterNeutral />,
  },
};

export function getStudentCategory({ studentTotalScore, achievementThreshold, meritThreshold }) {
  if (studentTotalScore >= achievementThreshold) {
    return ParticipationStatus.ACHIEVEMENT;
  } else if (studentTotalScore >= meritThreshold) {
    return ParticipationStatus.MERIT;
  } else {
    return ParticipationStatus.PARTICIPATION;
  }
}

const ResultBanner = ({ iconSrc, title, Footer, participation, event }) => {
  const previewModal = useRef(null);

  const handleOpenPreviewModal = () => {
    previewModal.current.open();
  };

  const handleClosePreviewModal = () => {
    previewModal.current.close();
  };

  const titleText = typeof title === 'function' ? title(event) : title;

  return (
    <div className="student-tasks-page__result-banner">
      <div className="student-tasks-page__result-banner-header">
        <SVG src={iconSrc}/>
      </div>
      <div className="student-tasks-page__result-banner-body">
        {titleText}
      </div>
      <div className="student-tasks-page__result-banner-footer">
        <Footer handleOpenPreviewModal={handleOpenPreviewModal} event={event} />
      </div>
      <CertificatePreviewModal src={participation?.preview} modal={previewModal} onClose={handleClosePreviewModal} />
    </div>
  )
}

const ResultBannerFooterPositive = ({ handleOpenPreviewModal, event }) => {
  const hintText = (event?.afterMainTour && event?.isAwardsAvailable) 
    ? 'Students who qualify for the Final Round will be invited to participate through their schools and chat messages.'
    : 'All certificates are saved in Certificates tab.\nYou can always find them there.';

  return (
    <div className="student-tasks-page__banner-positive">
      <div className="student-tasks-page__banner-positive-btn">
        <button onClick={handleOpenPreviewModal} className="btn" style={{ backgroundColor: '#9965F4' }}>
          OPEN
        </button>
      </div>
      <div className="student-tasks-page__banner-positive-hint" style={{ textAlign: 'center' }}>
        {hintText.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < hintText.split('\n').length - 1 && <br/>}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

const ResultBannerFooterNeutral = () => {
  return (
    <div className="student-tasks-page__result-footer-neutral">
      If you didn’t participate this time, there’s always a new chance!
      See&nbsp;you&nbsp;at the next Olympiad! 🚀
    </div>
  )
}

export default ResultBanner;
